import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import ReassuranceBar from './components/ReassuranceBar';
import ServiceCards from './components/ServiceCards';
import WhyUs from './components/WhyUs';
import ReviewsSection from './components/ReviewsSection';
import ProcessSteps from './components/ProcessSteps';
import ZoneIntervention from './components/ZoneIntervention';
import FAQSection from './components/FAQSection';
import CTAFinal from './components/CTAFinal';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    name: 'DFPRO Hérault',
    '@id': 'https://heraultroulettesbaiesvitrees.fr/#business',
    url: 'https://heraultroulettesbaiesvitrees.fr/',
    telephone: '+33980802242',
    email: 'herault@dfpro.fr',
    priceRange: '\u20AC\u20AC',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '100 route de Nîmes',
      addressLocality: 'Caissargues',
      postalCode: '30132',
      addressCountry: 'FR',
    },
    areaServed: [
      { '@type': 'City', name: 'Montpellier' },
      { '@type': 'AdministrativeArea', name: 'Hérault' },
    ],
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '08:00',
        closes: '20:00',
      },
    ],
    vatID: 'FR96984775262',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <SEO
        title="Réparation de baie coulissante dans l'Hérault | DFPRO"
        description="Baie coulissante qui coince, roulettes usées, volet ou vitrage en panne dans l'Hérault ? Intervention 24-48h, 7j/7. Devis gratuit, garantie 10 ans. Appelez !"
        canonicalUrl="https://heraultroulettesbaiesvitrees.fr/"
      />
      <HeroSection />
      <ReassuranceBar />
      <ServiceCards />
      <WhyUs />
      <ReviewsSection />
      <ProcessSteps />
      <ZoneIntervention />
      <FAQSection />
      <CTAFinal />
    </>
  );
}